const STORAGE_PREFIX = "mozzoapp:waiter-assistance:";
export const WAITER_ASSISTANCE_UPDATED_EVENT =
  "mozzoapp:waiter-assistance-updated";

const DEFAULT_OPTIONS = [
  { id: "servilletas", label: "Servilletas", active: true },
  { id: "sal", label: "Sal", active: true },
  { id: "mayonesa", label: "Mayonesa", active: true },
  { id: "cubiertos", label: "Tenedor, cuchillo y cuchara", active: true },
  { id: "vaso", label: "Vaso", active: true },
  { id: "copa", label: "Copa", active: true },
  { id: "aceite", label: "Aceite", active: true },
  { id: "vinagre", label: "Vinagre", active: true },
];

const createDefaultConfig = () => ({
  options: DEFAULT_OPTIONS.map((option) => ({ ...option })),
  allowCustomText: true,
  customTextLabel: "Aclaracion adicional",
  customTextPlaceholder: "Escribe aqui si necesitas algo fuera de la lista",
});

export const buildWaiterAssistanceStorageKey = (scopeId) =>
  `${STORAGE_PREFIX}${scopeId || "default"}`;

const cleanText = (value) => typeof value === "string" ? value.trim() : "";

export const normalizeWaiterAssistanceConfig = (payload) => {
  const base = createDefaultConfig();

  return {
    options: Array.isArray(payload?.options)
      ? payload.options
          .map((option, index) => ({
            id: cleanText(option?.id) || `custom-option-${index + 1}`,
            label: cleanText(option?.label) || `Opcion ${index + 1}`,
            active: option?.active !== false,
          }))
          .filter((option) => option.label)
      : base.options,
    allowCustomText: payload?.allowCustomText !== false,
    customTextLabel: cleanText(payload?.customTextLabel) || base.customTextLabel,
    customTextPlaceholder:
      cleanText(payload?.customTextPlaceholder) || base.customTextPlaceholder,
  };
};

const emitUpdate = (scopeId, config) => {
  if (typeof window === "undefined") {
    return;
  }

  window.dispatchEvent(
    new CustomEvent(WAITER_ASSISTANCE_UPDATED_EVENT, {
      detail: {
        scopeId: scopeId || "default",
        config,
      },
    })
  );
};

export const getWaiterAssistanceConfig = (scope) => {
  if (typeof window === "undefined") {
    return createDefaultConfig();
  }

  try {
    const rawValue = window.localStorage.getItem(
      buildWaiterAssistanceStorageKey(scope?.id || scope)
    );

    if (!rawValue) {
      return createDefaultConfig();
    }

    return normalizeWaiterAssistanceConfig(JSON.parse(rawValue));
  } catch (error) {
    console.error("No pudimos leer la configuracion de llamados al mozo:", error);
    return createDefaultConfig();
  }
};

export const saveWaiterAssistanceConfig = (scope, payload) => {
  const scopeId = scope?.id || scope;
  const normalized = normalizeWaiterAssistanceConfig(payload);

  if (typeof window === "undefined") {
    return normalized;
  }

  try {
    window.localStorage.setItem(
      buildWaiterAssistanceStorageKey(scopeId),
      JSON.stringify(normalized)
    );
    emitUpdate(scopeId, normalized);
  } catch (error) {
    console.error("No pudimos guardar la configuracion de llamados al mozo:", error);
    throw new Error("No se pudo guardar la configuracion del modulo mozo.");
  }

  return normalized;
};
